import React from 'react';
import { Layout, Text, ListItem, Icon, Card, RadioGroup, Radio, CheckBox, Button } from '@ui-kitten/components';
import { useQuery } from '@apollo/react-hooks';
import { Q_GET_SURVEY, Q_GET_SURVEY_PARTICIPANTS, Q_GET_SURVEY_QUESTION_RESPONSES } from '../../data/api/query/q_survey';
import { ListRenderItemInfo, FlatList, Platform, View } from 'react-native';
import { SurveyCard, CardItem, ItemTypeHeader, SurveyTypeHeader } from '../../components/list-items/CardItem';
import { PageLoadingIndicator } from '../../components/LoadingIndicator';
import { useScreenDimensions, getItemWidth } from '../../utils/useScreenInfo';
import { BasicCard, ListHeader } from '../../components/_primatives';




export function SurveyQuestionResponseListScreen({ navigation, route }): React.ReactElement {
    const { pageSpacerHorizontal, isMediumScreenOrLarger, bodyWidth } = useScreenDimensions();
    const params = route?.params;
    console.log({ navigation, route, params });
    const surveyId: string = params.survey_id;
    const questionId: string = params.question_id;
    const { loading, error, data } = useQuery(Q_GET_SURVEY_QUESTION_RESPONSES, {
        variables: { survey_id: surveyId, question_id: questionId },
        fetchPolicy: 'network-only'
    });


    if (loading) return <PageLoadingIndicator />;
    if (error) { console.log('useQuery', error); return <Text>Error :(</Text> };
    console.log('we have data, ', data)
    const survey: any = data.surveys[0];
    if (!survey || survey.length === 0) return <Text>Survey not found</Text>;

    const userAnswers: any = [...survey.user_answers, ...survey.anon_user_answers];

    const renderHeader = () => (
        <>
            <ListHeader
                title={'Responses'}
                isMediumScreenOrLarger={isMediumScreenOrLarger}
            >
                {isMediumScreenOrLarger ? <Text category='s1'>{`Total Responses ${userAnswers.length}`}</Text> : undefined }
            </ListHeader>
            <View style={{ borderWidth: 0, marginBottom: isMediumScreenOrLarger ? 20 : 0, paddingHorizontal: isMediumScreenOrLarger ? 0 : 23  }}>
                <Text category='h5'>{`${survey.survey_sections[0].questions[0].question_title}`}</Text>
            </View>
        </>
    );

    const renderFooter = () => (
        <BasicCard style={{ borderWidth: 0 }}>
            <Text category='p1'>{'\n'}</Text>
        </BasicCard>
    );

    const listEmptyComponent = () => (
        <BasicCard style={{ borderWidth: 0 }}>
            <Text category='p1'>{'This question doesn\'t have any responses yet'}</Text>
        </BasicCard>
    );

    const renderUser = ({ item }) => {
        console.log('participant = ', item);
        const response: ParticipantResponseUser = item;
        return (
            <ParticipantResponse
                username={response.user.username}
                answerText={response.answer_text}
                isMediumScreenOrLarger={isMediumScreenOrLarger}
            />
        );
    };
    const keyExtractor = (item: CardItem) => item.id;


    return (
        <Layout level='1' style={{ flex: 1 }}>
            <FlatList
                data={userAnswers}
                renderItem={renderUser}
                keyExtractor={keyExtractor}
                ListHeaderComponent={renderHeader}
                ListFooterComponent={renderFooter}
                ListEmptyComponent={listEmptyComponent}
                style={{ flex: 1, paddingHorizontal: pageSpacerHorizontal }}
                contentContainerStyle={isMediumScreenOrLarger ? { width: bodyWidth, alignSelf: 'center', paddingTop: 0 } : undefined}
            />
        </Layout>
    );
}



interface ParticipantResponseProps {
    username: string;
    answerText: string;
    status?: string;
    isMediumScreenOrLarger: boolean;
}

interface ParticipantResponseUser {
    answer_text: string;
    created_at: string;
    user: {
        username: string;
    }
}

const ParticipantResponse = (props: ParticipantResponseProps) => {
    const renderItemIcon = (style: any) => (
        <Icon {...style} name='person' />
    );

    return (
        // <BasicCard style={{ borderWidth: 0 }}>
        //     <ListItem
        //         title={props.answerText}
        //         description={props.username}
        //         icon={renderItemIcon}
        //         style={{ marginHorizontal: -20 }}
        //     />
        // </BasicCard>
        <BasicCard style={props.isMediumScreenOrLarger ? { marginBottom: 15 } : { borderWidth: 0 }}>
            <View style={{ flex: 1, flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center', }}>
                <Icon name={'corner-down-right'} style={{ marginRight: 20 }} height={25} width={25} fill='rgb(143, 155, 179)' />
                <View style={{ flex: 1 }}>
                    <Text category='s1' style={{ fontWeight: 'bold', flex: 1 }}>{props.answerText}</Text>
                    <Text category='p1' appearance='hint'>{props.username}</Text>
                </View>
            </View>
        </BasicCard>
    );
};